import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { CAPService } from "../../core/services/cap-service";
import { Router, ActivatedRoute } from "@angular/router";
import * as CryptoJS from "crypto-js";
import { AppComponent } from "../../app.component";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  //var route = '';
  IsCountryCarousel = false;
  IsTrunkCarousel = false;
  IsGatewayCarousel = false;
  IsCAPCarousel = false;
  IsprojectCarousel = false;
  IsGlobalCarousel = false;
  IsCountryDashboard = false;
  IsTrunkDashboard = false;
  IsGatewayDashboard = false;
  IsCAPDashboard = false;
  IsProjectSDashboard = false;
  IsGlobalDashboard = false;
  IsRegionalDashboard = false;
  IsRegionalCarousel = false;
  //showFeedbackMainDashboard:boolean =true;

  //var route = '';
  IsConfig = false;
  IsGateway = false;
  IsCallRates = false;
  IsCallRules = false;
  IsTelco = false;
  IsCurrencyConversion = false;
  IsCountryCodeConfiguration = false;
  IsDevice = false;
  IsCAPMap = false;
  IsDailInConference = false;
  IsAdmin = false;
  IsReports = false;
  IsPay = false;
  IsProject = false;
  IsEngineer = false;
  IsDestination = false;
  IsAuthcode = false;
  LoggedInEnterpriseId = "";
  ProfilePicURL;
  IsLogin = true;
  ProfileImage;
  EmptyImage;
  Role;
  dataLoader: boolean;
  // MYCASService.key = CryptoJS.enc.Utf8.parse($rootScope.key);
  // MYCASService.iv = CryptoJS.enc.Utf8.parse($rootScope.iv);
  // MYCASService.UserName = ($rootScope.UserName);
  // MYCASService.keyValue = ($rootScope.keyValue);

  constructor(
    private router: Router,
    private CAPService: CAPService,
    private _avRoute: ActivatedRoute,
    private appComponent: AppComponent
  ) {}

  ngOnInit(): void {
    this.dataLoader = true;
    this.CAPService.getEntId().subscribe((data) => {
      this.appComponent.LoggedInEnterpriseId = data[0].EnterpriseID;
      this.LoggedInEnterpriseId = this.CAPService.enterpriseid;
      this.appComponent.ProfilePicURL = data[0].ProfilePicURL;
      this.CAPService.GDNGS = data[0].GDNGS; // == 'True' ? this.CAPService.encryptedlogin('GDN').ciphertext.toString(): this.CAPService.encryptedlogin('GS').ciphertext.toString();
      this.CAPService.country = data[0].Country.replace(/^\s+|\s+$/gm, "");
      this.CAPService.CareerLevel = data[0].ManagerValidLevel;
      this.CAPService.DisplayName = data[0].DisplayName;
      this.CAPService.EmployeeNO = data[0].EmployeeNO;
      this.CAPService.EncryptEid = data[0].EncryptEid;
      this.CAPService.Encryptcallcharge = data[0].Encryptcallcharge;
      if (
        data[0].IndiaGroup == "True" ||
        data[0].EnterpriseID == "adam.tybor"
      ) {
        this.appComponent.IsLogin = true;
      } else {
        this.appComponent.IsLogin = false;
      }
      if (this.appComponent.ProfilePicURL === "NotFound") {
        this.appComponent.ProfileImage = false;
        this.appComponent.EmptyImage = true;
      } else {
        this.appComponent.ProfileImage = true;
        this.appComponent.EmptyImage = false;
      }
      //MYCASService.token = $("input[name='__RequestVerificationToken']").val();
      //this.MenuRoleforUser();
      this.appComponent.MenuRoleforUser();
      this.MenuRoleforUser();
      this.dataLoader = false;
    });
  }
  MenuRoleforUser() {
    this.CAPService.GetRoles(
      "N",
      encodeURIComponent(this.CAPService.enterpriseid),
       //this.CAPService.enterpriseid,
      "RolesDetails"
    ).subscribe((data) => {
      if(data.toString() == "Unauthorized Access"){
        alert("Unauthorized Access 404");
      }
      else{
      this.Role = { RolesData: data, selected: {} };
      this.dataLoader = false;
      if (this.Role.RolesData.length > 0) {
        this.Role.RolesData.forEach((data) => {
          this.CAPService.Role = data.rolename;

          //  if (this.CAPService.country == 'India' && this.CAPService.Role != 'Global Admin') {
          //     window.location.href ='https://mycalls-india.accenture.com';
          // }

          this.CAPService.DeviceType = data.DeviceType;
          if (data.rolename == "Regional Voice Admin") {
            this.IsConfig = true;
            this.IsGateway = true;
            this.IsCallRates = true;
            this.IsCallRules = true;
            this.IsTelco = true;
            this.IsCurrencyConversion = true;
            this.IsCountryCodeConfiguration = false;
            this.IsDevice = true;
            this.IsCAPMap = true;
            this.IsDailInConference = true;
            this.IsAdmin = true;
            this.IsReports = true;
            this.Action("Regional");
            this.IsPay = true;
            this.IsProject = true;
            this.IsEngineer = true;
            this.IsDestination = true;
            this.IsAuthcode = true;
          }
          if (data.rolename == "Global Admin") {
            this.IsConfig = true;
            this.IsGateway = true;
            this.IsCallRates = true;
            this.IsCallRules = true;
            this.IsTelco = true;
            this.IsCurrencyConversion = true;
            this.IsCountryCodeConfiguration = true;
            this.IsDevice = true;
            this.IsCAPMap = true;
            this.IsDailInConference = true;
            this.IsAdmin = true;
            this.IsReports = true;
            this.IsGlobalCarousel = true;
            this.IsProject = true;
            this.IsProjectSDashboard = false;
            this.IsprojectCarousel = false;
            this.Action("Regional");
            this.IsPay = true;
            this.IsGlobalDashboard = true;
            this.IsEngineer = true;
            this.IsDestination = true;
            this.IsAuthcode = true;
          }
          if (data.rolename == "Gateway Access") {
            this.IsConfig = true;
            this.IsGateway = true;
            this.Action("Other");
          }
          if (data.rolename == "Call Rates Access") {
            this.IsConfig = true;
            this.IsCallRates = true;
            this.Action("Other");
          }
          if (data.rolename == "Call Rules Access") {
            this.IsConfig = true;
            this.IsCallRules = true;
            this.Action("Other");
          }
          if (data.rolename == "Telco Access") {
            this.IsConfig = true;
            this.IsTelco = true;
            this.Action("Other");
          }
          if (data.rolename == "Currency Conversion Access") {
            this.IsConfig = true;
            this.IsCurrencyConversion = true;
            this.Action("Other");
          }
          if (data.rolename == "Country Code Configuration Access") {
            this.IsConfig = true;
            this.IsCountryCodeConfiguration = true;
            this.Action("Other");
          }
          if (data.rolename == "Device Access") {
            this.IsConfig = true;
            this.IsDevice = true;
            this.Action("Other");
          }
          if (data.rolename == "CAPM Access") {
            this.IsConfig = true;
            this.IsCAPMap = true;
            this.Action("Other");
          }
          if (
            data.rolename == "Call Charge Report Access" ||
            data.rolename == "Trunk Group Report Access" ||
            data.rolename == "Gateway Group Report Access" ||
            data.rolename == "Group Report" ||
            data.rolename == "CAPM Report Access" ||
            data.rolename == "Recovery Reports" ||
            data.rolename == "Utilization Reports"
          ) {
            this.IsReports = true;
            this.CAPService.ReportRole = data.rolename;
          }
          if (data.rolename == "RTP Access") {
            this.IsPay = true;
            this.IsAuthcode = false;
            this.IsReports = true;
            this.Action("Other");
          }
          if (data.rolename == "Engineer Access") {
            this.IsEngineer = true;
            // this.IsConfig = false;
            this.Action("Other");
          }
          if (data.rolename == "Destination Acces") {
            this.IsDestination = true;
            this.Action("Other");
          }
          // if (data.rolename == "Finance Report") {
          //   this.IsConfig = false;
          //   this.IsReports = true;
          //   this.Action("Other");
          //   this.CAPService.ReportRole = data.rolename;
          //   this.CAPService.DeviceType = data.DeviceType;
          // }
        });
      }
      }
    });
  }

  Action(type) {
    if (type == "Regional") {
      this.IsRegionalDashboard = true;
      this.IsRegionalCarousel = true;
      this.dataLoader = false;
    } else if (type == "Other") {
      this.IsRegionalDashboard = false;
      this.IsRegionalCarousel = false;
      this.IsprojectCarousel = false;
      this.IsGlobalCarousel = false;
      this.IsProjectSDashboard = false;
      this.IsGlobalDashboard = false;
      this.dataLoader = false;
    }
  }
}
